import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/config'
import VueCookie from 'vue-cookie'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Auth/Login.vue'),
    beforeEnter (from, to, next) {
      if (!VueCookie.get(process.env.VUE_APP_TOKEN)) next()
      else next('/dashboard')
    }
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard/Index.vue'),
    meta: { requiresAuth: true, techRoleAccess: true, officeRoleAccess: true }
  }, {
    path: '/resetpassword',
    name: 'resetpassword',
    component: () => import('@/views/Auth/ResetPassword.vue')
  }, {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: () => import('@/views/Auth/ForgotPassword.vue')
  }, {
    path: '/customers',
    component: () => import('@/views/Customer/Index.vue'),
    meta: { requiresAuth: true, officeRoleAccess: true },
    children: [{
      path: '/',
      name: 'customers',
      component: () => import('@/views/Customer/List.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    },
    {
      path: 'actions/:crm_id?',
      name: 'customers_actions',
      component: () => import('@/views/Customer/Action.vue'),
      meta: { officeRoleAccess: true }
    }]
  }, {
    path: '/department',
    component: () => import('@/views/Department/List.vue')
  }, {
    path: '/crm_priorities',
    component: () => import('@/views/Customer/Priorities/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/crm_shipments',
    component: () => import('@/views/Customer/Shipments/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/crm_industries',
    component: () => import('@/views/Customer/Industries/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/orders',
    component: () => import('../views/Order/View.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '',
      name: 'order_list',
      component: () => import('../views/Order/List.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }, {
      path: 'actions/:order_id?',
      name: 'orders_actions',
      component: () => import('../views/Order/Actions.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }]
  }, {
    path: '/w_h',
    component: () => import('@/views/Warehouse/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: 'stocks',
      name: 'stocklist',
      component: () => import('@/views/Warehouse/Stock/List.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }, {
      path: 'products',
      component: () => import('@/views/Warehouse/Product/Index.vue'),
      children: [{
        path: '/',
        name: 'warehouse_products',
        component: () => import('@/views/Warehouse/Product/List.vue'),
        meta: { techRoleAccess: true, officeRoleAccess: true }
      }, {
        path: 'actions/:product_id?',
        name: 'warehouse_products_actions',
        component: () => import('@/views/Warehouse/Product/Action.vue'),
        meta: { officeRoleAccess: true }
      }]
    }, {
      path: 'ccsheet',
      component: () => import('@/views/Warehouse/CCSheet/Index.vue'),
      children: [{
        path: '/',
        name: 'ccsheet',
        component: () => import('@/views/Warehouse/CCSheet/List.vue'),
        meta: { techRoleAccess: true, officeRoleAccess: true }
      }, {
        path: 'actions/:sheet_id?/:has_edit?',
        name: 'ccsheet_actions',
        component: () => import('@/views/Warehouse/CCSheet/Action.vue'),
        meta: { officeRoleAccess: true }
      }, {
        path: 'adjustment_order/:sheet_id',
        name: 'sheet_adjustment',
        component: () => import('@/views/Warehouse/CCSheet/AdjustmentOrder.vue'),
        meta: { officeRoleAccess: true }
      }]
    }, {
      path: 'order',
      component: () => import('@/views/Warehouse/Order/Index.vue'),
      children: [{
        path: '/',
        name: 'warehouse_order',
        component: () => import('@/views/Warehouse/Order/List.vue'),
        meta: { techRoleAccess: true, officeRoleAccess: true }
      }, {
        path: 'supplierorder/actions/:supp_id?',
        name: 'supporder_actions',
        component: () => import('@/views/Warehouse/Order/SupplierOrder.vue'),
        meta: { officeRoleAccess: true }
      }, {
        path: 'lowstockproposal',
        name: 'low_stock_proposal',
        component: () => import('@/views/Warehouse/Order/LowStockProposal.vue'),
        meta: { officeRoleAccess: true }
      }, {
        path: 'adjustmentorder/actions/:adjust_id?',
        name: 'adjustorder_actions',
        component: () => import('@/views/Warehouse/Order/AdjustmentOrder.vue'),
        meta: { officeRoleAccess: true }
      }, {
        path: 'returnorder/actions/:return_id?',
        name: 'returnorder_actions',
        component: () => import('@/views/Warehouse/Order/ReturnOrder.vue'),
        meta: { officeRoleAccess: true }
      }, {
        path: 'transferorder/actions/:transfer_id?',
        name: 'transferorder_actions',
        component: () => import('@/views/Warehouse/Order/TransferOrder.vue'),
        meta: { officeRoleAccess: true }
      }]
    }]
  }, {
    path: '/production_order',
    component: () => import('@/views/ProductionOrder/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: 'order',
      component: () => import('@/views/ProductionOrder/Order/Index.vue'),
      children: [{
        path: '/',
        name: 'production_order',
        component: () => import('@/views/ProductionOrder/Order/List.vue'),
        meta: { techRoleAccess: true, officeRoleAccess: true }
      }, {
        path: 'actions/:id?',
        name: 'production_orderactions',
        component: () => import('@/views/ProductionOrder/Order/Action.vue'),
        meta: { techRoleAccess: true, officeRoleAccess: true }
      }]
    }, {
      path: 'archived',
      component: () => import('@/views/ProductionOrder/ArchivedList.vue'),
      name: 'archived',
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }, {
      path: 'by_product',
      component: () => import('@/views/ProductionOrder/ProductList.vue'),
      name: 'by_product',
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }, {
      path: 'in_production',
      component: () => import('@/views/ProductionOrder/InProduction.vue'),
      name: 'in_production',
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }]
  }, {
    path: '/reports',
    component: () => import('@/views/Reports/Index.vue'),
    name: 'reports',
    meta: { requiresAuth: true, techRoleAccess: true, officeRoleAccess: true }
  }, {
    path: '/deviations',
    component: () => import('@/views/Deviation/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'deviations',
      component: () => import('@/views/Deviation/List.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    },
    {
      path: 'actions/:deviation_id?',
      name: 'deviations_actions',
      component: () => import('@/views/Deviation/Action.vue'),
      meta: { officeRoleAccess: true }
    }]
  }, {
    path: '/deviation_category',
    component: () => import('@/views/Deviation/Category/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/deviation_status',
    component: () => import('@/views/Deviation/Status/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/deviation_location',
    component: () => import('@/views/Deviation/Location/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/users',
    component: () => import('@/views/Employees/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'users',
      component: () => import('@/views/Employees/List.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }, {
      path: 'actions/:user_id?',
      name: 'user_actions',
      component: () => import('@/views/Employees/Actions.vue'),
      meta: { techRoleAccess: true, officeRoleAccess: true }
    }]
  }, {
    path: '/user_roles',
    component: () => import('@/views/UserRole/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/sharepoint',
    component: () => import('@/views/SharePointSetting/Action.vue')
  }, {
    path: '/salesaccounts',
    component: () => import('@/views/SalesAccount/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/currencies',
    component: () => import('@/views/Currency/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'currencies',
      component: () => import('@/views/Currency/List.vue')
    }, {
      path: 'actions/:currency_id?',
      name: 'currency_actions',
      component: () => import('@/views/Currency/Action.vue')
    }]
  }, {
    path: '/permissions',
    component: () => import('@/views/Permission/List.vue'),
    meta: { requiresAuth: true, isSuperAdmin: true }
  }, {
    path: '/product_workflow',
    component: () => import('@/views/ProductWorkFlow/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/workflow_states',
    component: () => import('@/views/WorkFlowStates/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/settings/warehouse',
    component: () => import('@/views/WarehouseSettings/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'warehouse',
      component: () => import('@/views/WarehouseSettings/List.vue')
    }]
  }, {
    path: '/warehouse_location',
    component: () => import('@/views/WarehouseLocation/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'warehouselocation',
      component: () => import('@/views/WarehouseLocation/List.vue')
    }]
  }, {
    path: '/product_units',
    component: () => import('@/views/ProductUnit/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/product_groups',
    component: () => import('@/views/ProductGroup/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/grossmargins',
    component: () => import('@/views/GrossMargin/List.vue'),
    meta: { requiresAuth: true }
  },
  // {
  // path: '/discountgroups',
  // component: () => import('@/views/DiscountGroups/Index.vue'),
  // meta: { requiresAuth: true }
  // },
  {
    path: '/tools',
    component: () => import('@/views/Tools/List.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/product_class',
    component: () => import('@/views/ProductClass/productclass.vue'),
    meta: { requiresAuth: true }
  }, {
    path: '/return_forms',
    component: () => import('@/views/ReturnForm/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'return_forms',
      component: () => import('@/views/ReturnForm/List.vue')
    }, {
      path: 'actions/:id?',
      name: 'add_update_form',
      component: () => import('@/views/ReturnForm/Actions.vue')
    }]
  }, {
    path: '/checklist_templates',
    component: () => import('@/views/Checklist/Settings/Templates/Index.vue'),
    meta: { requiresAuth: true },
    children: [{
      path: '/',
      name: 'templates',
      component: () => import('@/views/Checklist/Settings/Templates/List.vue')
    }]
  }, {
    path: '/properties',
    meta: { requiresAuth: true },
    component: () => import('@/views/Checklist/Settings/Properties.vue')
  }]
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(VueCookie.get(process.env.VUE_APP_USER))
  if (to.name && to.name.includes('add_update_form')) next()
  else {
    const userRoleId = user ? user.id === -100 ? 1 : user.role_id : 0
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!VueCookie.get(process.env.VUE_APP_TOKEN)) {
        store.dispatch('logout')
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      } else if (userRoleId === 1) next()
      else if (userRoleId === 2 && to.meta.officeRoleAccess) next()
      else if (userRoleId === 3 && to.meta.techRoleAccess) next()
    } else next()
  }
})

export default router
